import component from './presenter';

export default component;
